import { html, render } from "lit-html";
import { connect } from "../connect-with-dialog";
import { translate } from "../../../shared/l10n/translate";
import { FilterDialog } from "./FilterDialog";
import "./FilterCounter";

customElements.define(
	"esc-filter-dialog-button",
	connect(
		FilterDialog,
		class extends HTMLElement {
			connectedCallback() {
				render(
					html`<button>
						<esc-hotel-list-filter-counter
							class="fa--space-after"
							show-icon
						></esc-hotel-list-filter-counter>
						${translate("filter_bar_label_filter_summary")}
					</button>`,
					this,
				);
			}
		},
	),
);
